import eventBus from './eventBus'

export function mobileCallJsMethodNoResult (message) {
  console.log('mobileCallJsMethodNoResult', message)
  let messageParse = message
  if (typeof message === 'string') {
    messageParse = message && JSON.parse(message)
  }
  let data = messageParse.params
  if (messageParse.params && !Array.isArray(messageParse.params)) {
    data = [messageParse.params]
  }
  // const messageParse = message && JSON.parse(message)
  eventBus.emit(messageParse.method, {type: messageParse.method, data: data, ...messageParse})
}

// export default function sendAppData (data) {
//   const message = JSON.stringify(data)
//   console.log('sendAppData', message)
//   // eslint-disable-next-line no-undef
//   // fangcloud.postMessage(message)
//   return new Promise((resolve, reject) => {
//     // eventBus.emit('fileList', {type: 'fileList', data: [{name: '1111'}]})
//     resolve()
//   })
// }
